import React from 'react';
import {FormControlLabel, FormGroup} from '@material-ui/core';
import {EfeCheckbox} from 'components';

function Check() {
    return (
        <FormGroup>
            <FormControlLabel
                control={<EfeCheckbox />}
                label='Default Checkbox'
            />
            <FormControlLabel
                control={<EfeCheckbox defaultChecked />}
                label='Checked Checkbox'
            />
            <FormControlLabel
                control={<EfeCheckbox indeterminate />}
                label='Mixed Checkbox'
            />
        </FormGroup>
    );
}

export default Check;
